// import { useEffect, useState } from "react";
// import { FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import PageHeader from "../components/PageHeader";
// import SectionTitle from "../components/SectionTitle";
// import { galleryData, galleryCategories } from "../data/galleryData";
// import "../styles/Pages.css";
// import "../styles/Gallery.css";

// const Gallery = () => {
//   const [filter, setFilter] = useState("all");
//   const [lightbox, setLightbox] = useState(null);

//   useEffect(() => { document.title = "Gallery | USHA Resort, Patna"; }, []);

//   const filtered = filter === "all" ? galleryData : galleryData.filter((g) => g.category === filter);

//   // Keyboard navigation for lightbox
//   useEffect(() => {
//     if (lightbox === null) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") setLightbox(null);
//       if (e.key === "ArrowRight") setLightbox((i) => (i + 1) % filtered.length);
//       if (e.key === "ArrowLeft") setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [lightbox, filtered.length]);

//   return (
//     <>
//       <PageHeader
//         title="Our Gallery"
//         subtitle="Home · Gallery"
//         image="https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1800&q=80"
//       />

//       <section className="gallery-page">
//         <div className="container">
//           <SectionTitle
//             tag="Gallery"
//             title="Moments at USHA Resort"
//             subtitle="A glimpse of the experiences waiting for you."
//           />

//           <div className="gallery-filters">
//             {galleryCategories.map((cat) => (
//               <button
//                 key={cat}
//                 className={filter === cat ? "active" : ""}
//                 onClick={() => setFilter(cat)}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>

//           <div className="gallery-grid">
//             {filtered.map((item, index) => (
//               <div className="gallery-item" key={item.id} onClick={() => setLightbox(index)}>
//                 <img src={item.src} alt={item.alt} loading="lazy" />
//                 <div className="g-overlay"><FaSearchPlus /></div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Lightbox */}
//         {lightbox !== null && filtered[lightbox] && (
//           <div className="lightbox" onClick={() => setLightbox(null)}>
//             <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
//               <FaTimes />
//             </button>
//             <button
//               className="lightbox-arrow left"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + filtered.length) % filtered.length); }}
//               aria-label="Previous image"
//             >
//               <FaChevronLeft />
//             </button>
//             <img
//               src={filtered[lightbox].src.replace("w=900", "w=1600")}
//               alt={filtered[lightbox].alt}
//               onClick={(e) => e.stopPropagation()}
//             />
//             <button
//               className="lightbox-arrow right"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % filtered.length); }}
//               aria-label="Next image"
//             >
//               <FaChevronRight />
//             </button>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default Gallery;


// import { useEffect, useState } from "react";
// import { FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import PageHeader from "../components/PageHeader";
// import SectionTitle from "../components/SectionTitle";
// import { galleryData, galleryCategories } from "../data/galleryData";
// import "../styles/Pages.css";
// import "../styles/Gallery.css";

// const Gallery = () => {
//   const [filter, setFilter] = useState("all");
//   const [lightbox, setLightbox] = useState(null);

//   useEffect(() => { document.title = "Gallery | USHA Resort, Patna"; }, []);

//   const filtered = filter === "all" ? galleryData : galleryData.filter((g) => g.category === filter);

//   // Keyboard navigation for lightbox (Esc = close, ← → = prev/next)
//   useEffect(() => {
//     if (lightbox === null) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") setLightbox(null);
//       if (e.key === "ArrowRight") setLightbox((i) => (i + 1) % filtered.length);
//       if (e.key === "ArrowLeft") setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [lightbox, filtered.length]);

//   return (
//     <>
//       <PageHeader
//         title="Our Gallery"
//         subtitle="Home · Gallery"
//         image="/images/Slider/7.png"
//       />

//       <section className="gallery-page">
//         <div className="container">
//           <SectionTitle
//             tag="Gallery"
//             title="Moments at USHA Resort"
//             subtitle="A glimpse of the experiences waiting for you."
//           />

//           {/* Filter buttons */}
//           <div className="gallery-filters">
//             {galleryCategories.map((cat) => (
//               <button
//                 key={cat}
//                 className={filter === cat ? "active" : ""}
//                 onClick={() => setFilter(cat)}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>

//           {/* Gallery grid — images come from src/data/galleryData.js */}
//           <div className="gallery-grid">
//             {filtered.map((item, index) => (
//               <div className="gallery-item" key={item.id} onClick={() => setLightbox(index)}>
//                 <img src={item.src} alt={item.alt} loading="lazy" />
//                 <div className="g-overlay"><FaSearchPlus /></div>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Lightbox */}
//         {lightbox !== null && filtered[lightbox] && (
//           <div className="lightbox" onClick={() => setLightbox(null)}>
//             <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
//               <FaTimes />
//             </button>
//             <button
//               className="lightbox-arrow left"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + filtered.length) % filtered.length); }}
//               aria-label="Previous image"
//             >
//               <FaChevronLeft />
//             </button>
//             <img
//               src={filtered[lightbox].src}
//               alt={filtered[lightbox].alt}
//               onClick={(e) => e.stopPropagation()}
//             />
//             <button
//               className="lightbox-arrow right"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % filtered.length); }}
//               aria-label="Next image"
//             >
//               <FaChevronRight />
//             </button>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default Gallery;

// //src/pages/Gallery.js

// import { useEffect, useState } from "react";
// import { FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import PageHeader from "../components/PageHeader";
// import SectionTitle from "../components/SectionTitle";
// import { galleryData, galleryCategories } from "../data/galleryData";
// import "../styles/Pages.css";
// import "../styles/Gallery.css";

// // 👇 How many photos to show at once
// const PHOTOS_PER_PAGE = 12;

// const Gallery = () => {
//   const [filter, setFilter] = useState("all");
//   const [visibleCount, setVisibleCount] = useState(PHOTOS_PER_PAGE);
//   const [lightbox, setLightbox] = useState(null);

//   useEffect(() => { document.title = "Gallery | USHA Resort, Patna"; }, []);

//   const filtered = filter === "all" ? galleryData : galleryData.filter((g) => g.category === filter);

//   // 👇 Only render the first `visibleCount` photos
//   const visiblePhotos = filtered.slice(0, visibleCount);
//   const hasMore = visibleCount < filtered.length;

//   // 👇 Reset count back to 10 whenever filter changes
//   useEffect(() => {
//     setVisibleCount(PHOTOS_PER_PAGE);
//   }, [filter]);

//   // Keyboard navigation for lightbox (Esc = close, ← → = prev/next)
//   // Navigates through ALL filtered photos, not just the visible ones
//   useEffect(() => {
//     if (lightbox === null) return;
//     const onKey = (e) => {
//       if (e.key === "Escape") setLightbox(null);
//       if (e.key === "ArrowRight") setLightbox((i) => (i + 1) % filtered.length);
//       if (e.key === "ArrowLeft") setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
//     };
//     window.addEventListener("keydown", onKey);
//     return () => window.removeEventListener("keydown", onKey);
//   }, [lightbox, filtered.length]);

//   return (
//     <>
//       <PageHeader
//         title="Our Gallery"
//         subtitle="Home · Gallery"
//         image="/images/Slider/7.png"
//       />

//       <section className="gallery-page">
//         <div className="container">
//           <SectionTitle
//             tag="Gallery"
//             title="Moments at USHA Resort"
//             subtitle="A glimpse of the experiences waiting for you."
//           />

//           {/* Filter buttons */}
//           <div className="gallery-filters">
//             {galleryCategories.map((cat) => (
//               <button
//                 key={cat}
//                 className={filter === cat ? "active" : ""}
//                 onClick={() => setFilter(cat)}
//               >
//                 {cat}
//               </button>
//             ))}
//           </div>

//           {/* Gallery grid — renders only visiblePhotos (10 at a time) */}
//           <div className="gallery-grid">
//             {visiblePhotos.map((item, index) => (
//               <div className="gallery-item" key={item.id} onClick={() => setLightbox(index)}>
//                 <img src={item.src} alt={item.alt} loading="lazy" />
//                 <div className="g-overlay"><FaSearchPlus /></div>
//               </div>
//             ))}
//           </div>

//           {/* 👇 Load More button */}
//           {hasMore && (
//             <div className="gallery-load-more">
//               <button
//                 className="btn btn-outline-dark"
//                 onClick={() => setVisibleCount((c) => c + PHOTOS_PER_PAGE)}
//               >
//                 Load More Photos ({filtered.length - visibleCount} More)
//               </button>
//               <p>Showing {visiblePhotos.length} of {filtered.length} photos</p>
//             </div>
//           )}
//         </div>

//         {/* Lightbox */}
//         {lightbox !== null && filtered[lightbox] && (
//           <div className="lightbox" onClick={() => setLightbox(null)}>
//             <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
//               <FaTimes />
//             </button>
//             <button
//               className="lightbox-arrow left"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + filtered.length) % filtered.length); }}
//               aria-label="Previous image"
//             >
//               <FaChevronLeft />
//             </button>
//             <img
//               src={filtered[lightbox].src}
//               alt={filtered[lightbox].alt}
//               onClick={(e) => e.stopPropagation()}
//             />
//             <button
//               className="lightbox-arrow right"
//               onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % filtered.length); }}
//               aria-label="Next image"
//             >
//               <FaChevronRight />
//             </button>
//           </div>
//         )}
//       </section>
//     </>
//   );
// };

// export default Gallery;


//src/pages/Gallery.js

import { useEffect, useState } from "react";
import {
  FaSearchPlus, FaTimes, FaChevronLeft, FaChevronRight,
  FaImages, FaVideo, FaPlay,
} from "react-icons/fa";
import PageHeader from "../components/PageHeader";
import SectionTitle from "../components/SectionTitle";
import { galleryData, galleryCategories } from "../data/galleryData";
import { videosData } from "../data/videosData";
import "../styles/Pages.css";
import "../styles/Gallery.css";

// 👇 How many photos to show at once
const PHOTOS_PER_PAGE = 12;

const Gallery = () => {
  const [media, setMedia] = useState("photos");       // 👈 "photos" | "videos"
  const [filter, setFilter] = useState("all");
  const [visibleCount, setVisibleCount] = useState(PHOTOS_PER_PAGE);
  const [lightbox, setLightbox] = useState(null);     // photo index (photos mode)
  const [activeVideo, setActiveVideo] = useState(null); // 👈 video object (videos mode)

  useEffect(() => { document.title = "Gallery | USHA Resort, Patna"; }, []);

  const filtered = filter === "all" ? galleryData : galleryData.filter((g) => g.category === filter);

  const visiblePhotos = filtered.slice(0, visibleCount);
  const hasMore = visibleCount < filtered.length;

  // Reset count whenever filter changes
  useEffect(() => {
    setVisibleCount(PHOTOS_PER_PAGE);
  }, [filter]);

  // Keyboard: Esc closes lightbox / video modal
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") { setLightbox(null); setActiveVideo(null); }
      if (media !== "photos" || lightbox === null) return;
      if (e.key === "ArrowRight") setLightbox((i) => (i + 1) % filtered.length);
      if (e.key === "ArrowLeft") setLightbox((i) => (i - 1 + filtered.length) % filtered.length);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [lightbox, filtered.length, media]);

  return (
    <>
      <PageHeader
        title="Our Gallery"
        subtitle="Home · Gallery"
        image="/images/Slider/7.png"
      />

      <section className="gallery-page">
        <div className="container">
          <SectionTitle
            tag="Gallery"
            title="Moments at USHA Resort"
            subtitle="A glimpse of the experiences waiting for you."
          />

          {/* 👇 Photos / Videos toggle */}
          <div className="media-toggle">
            <button
              className={media === "photos" ? "active" : ""}
              onClick={() => { setMedia("photos"); setLightbox(null); }}
            >
              <FaImages /> Photos
            </button>
            <button
              className={media === "videos" ? "active" : ""}
              onClick={() => { setMedia("videos"); setActiveVideo(null); }}
            >
              <FaVideo /> Videos
            </button>
          </div>

          {/* ================= PHOTOS MODE ================= */}
          {media === "photos" && (
            <>
              <div className="gallery-filters">
                {galleryCategories.map((cat) => (
                  <button
                    key={cat}
                    className={filter === cat ? "active" : ""}
                    onClick={() => setFilter(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>

              <div className="gallery-grid">
                {visiblePhotos.map((item, index) => (
                  <div className="gallery-item" key={item.id} onClick={() => setLightbox(index)}>
                    <img src={item.src} alt={item.alt} loading="lazy" />
                    <div className="g-overlay"><FaSearchPlus /></div>
                  </div>
                ))}
              </div>

              {hasMore && (
                <div className="gallery-load-more">
                  <button
                    className="btn btn-outline-dark"
                    onClick={() => setVisibleCount((c) => c + PHOTOS_PER_PAGE)}
                  >
                    Load More Photos ({filtered.length - visibleCount} More)
                  </button>
                  <p>Showing {visiblePhotos.length} of {filtered.length} photos</p>
                </div>
              )}
            </>
          )}

          {/* ================= VIDEOS MODE ================= */}
          {media === "videos" && (
            <div className="videos-grid">
              {videosData.map((video) => (
                <div className="video-card" key={video.id} onClick={() => setActiveVideo(video)}>
                  <div className="video-thumb">
                    <img
                      src={video.type === "youtube"
                        ? `https://img.youtube.com/vi/${video.youtubeId}/hqdefault.jpg`
                        : video.thumb}
                      alt={video.title}
                      loading="lazy"
                    />
                    <div className="video-overlay">
                      <span className="play-btn"><FaPlay /></span>
                    </div>
                  </div>
                  <h4>{video.title}</h4>
                </div>
              ))}

              {videosData.length === 0 && (
                <p className="videos-empty">No videos yet — check back soon!</p>
              )}
            </div>
          )}
        </div>

        {/* ================= PHOTO LIGHTBOX ================= */}
        {media === "photos" && lightbox !== null && filtered[lightbox] && (
          <div className="lightbox" onClick={() => setLightbox(null)}>
            <button className="lightbox-close" onClick={() => setLightbox(null)} aria-label="Close">
              <FaTimes />
            </button>
            <button
              className="lightbox-arrow left"
              onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i - 1 + filtered.length) % filtered.length); }}
              aria-label="Previous image"
            >
              <FaChevronLeft />
            </button>
            <img
              src={filtered[lightbox].src}
              alt={filtered[lightbox].alt}
              onClick={(e) => e.stopPropagation()}
            />
            <button
              className="lightbox-arrow right"
              onClick={(e) => { e.stopPropagation(); setLightbox((i) => (i + 1) % filtered.length); }}
              aria-label="Next image"
            >
              <FaChevronRight />
            </button>
          </div>
        )}

        {/* ================= VIDEO MODAL ================= */}
        {media === "videos" && activeVideo && (
          <div className="lightbox" onClick={() => setActiveVideo(null)}>
            <button className="lightbox-close" onClick={() => setActiveVideo(null)} aria-label="Close video">
              <FaTimes />
            </button>
            <div className="video-frame" onClick={(e) => e.stopPropagation()}>
              {activeVideo.type === "youtube" ? (
                <iframe
                  src={`https://www.youtube.com/embed/${activeVideo.youtubeId}?autoplay=1`}
                  title={activeVideo.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <video src={activeVideo.src} controls autoPlay />
              )}
            </div>
          </div>
        )}
      </section>
    </>
  );
};

export default Gallery;